import React, {useState, useEffect} from 'react';
import {Table} from 'reactstrap'
import {connect} from 'react-redux';
import {FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCcVisa, faCcMastercard} from '@fortawesome/free-brands-svg-icons';

const ExtratoConta = ({payments}) => {
    return(
        <div>
           <Table responsive>
                <thead>
                <tr>
                    <th>Data</th>
                    <th>Forma de pagamento</th>
                    <th>Total</th>
                </tr>
                </thead>
                <tbody>
                    {payments.map(item => {
                        let date = new Date(item.created_at);
                        date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
                        console.log(date);

                        const value = `${item.amount}`.replace('.',',');
                        
                        return (
                            <tr key={`payment-${item.id}`}>
                                <th scope="row">{date}</th>
                                <td style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingVertical: 0}}>
                                    <div>
                                        <FontAwesomeIcon 
                                            icon={faCcVisa}
                                            color="#25313B"
                                            transform="grow-14"
                                        />
                                    </div>
                                    <p className="ml-3 mb-0">**** **** **** 4321</p>
                                </td>
                                <td>C$ {value}</td>
                            </tr>
                        )
                    })}
                {/* <tr>
                    <th scope="row">03/08/2019</th>
                    <td style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingVertical: 0}}>
                        <div>
                            <FontAwesomeIcon 
                                icon={faCcVisa}
                                color="#25313B"
                                transform="grow-14"
                            />
                        </div>
                        <p className="ml-3 mb-0">**** **** **** 4321</p>
                    </td>
                    <td>C$ 160,00</td>
                </tr> */}
                </tbody>
            </Table>
        </div>
    );
}

export default ExtratoConta;
